<template>
  <base-drawer
    :open="openDrawer"
    :close="closedDrawer"
    :title="getTitle()"
    :closeInFade="false"
    @onClose="onCloseDrawer()"
    ref="addDrawer"
  >
    <!-- Contents -->
    <div v-if="targetItem.type === 'category'">
      <!-- se o item é categoria -->
      <base-steps
        ref="stepper"
        hideButtons
        class="d-flex flex-column"
        style="min-height: 100%; align-items: stretch"
      >
        <div v-show="currentStep === 1">
          <edit-step
            v-if="editMode"
            :targetItem="targetItem"
            @saveItem="save"
          />
          <select-category-step
            v-else
            :targetItem="targetItem"
            @onSelect="next"
          />
        </div>
        <div v-show="currentStep === 2" :class="editMode ? 'inactive' : ''">
          <select-size-step
            v-if="!editMode"
            ref="categoryStep2"
            :targetItem="targetItem"
          />
        </div>
        <div
          v-show="currentStep === 3"
          :class="!showAllSteps ? 'inactive' : ''"
        >
          <set-extra-ingredients-step
            v-if="targetItem.mode === 'step' && targetItem.sizes.length === 1"
            :targetItem="targetItem"
          />
          <select-drink-size-step
            ref="categoryStep3"
            v-else-if="
              targetItem.mode === 'drink' && targetItem.sizes.length > 1
            "
            :targetItem="targetItem"
          />
          <set-sizes-step ref="categoryStep3" v-else :targetItem="targetItem" />
        </div>
        <div
          v-show="currentStep === 4"
          :class="!showAllSteps ? 'inactive' : ''"
        >
          <set-availability-step
            v-if="
              (targetItem.mode === 'step' && targetItem.sizes.length === 1) ||
                (targetItem.mode === 'drink' && !targetItem.default_sizes)
            "
            :targetItem="targetItem"
          />
          <set-extra-ingredients-step
            v-else-if="
              (targetItem.mode === 'step' && targetItem.sizes.length > 1) ||
                (targetItem.mode === 'drink' && targetItem.sizes.length === 1)
            "
            :targetItem="targetItem"
          />
          <set-sizes-step
            v-else-if="
              targetItem.mode === 'drink' && targetItem.sizes.length > 1
            "
            :targetItem="targetItem"
          />
          <set-doughs-step v-else :targetItem="targetItem" />
        </div>
        <div
          v-show="currentStep === 5"
          :class="
            !showAllSteps ||
            (targetItem.mode === 'step' && targetItem.sizes.length === 1) ||
            (targetItem.mode === 'drink' && !targetItem.default_sizes)
              ? 'inactive'
              : ''
          "
        >
          <set-availability-step
            v-if="
              targetItem.mode === 'step' ||
                (targetItem.mode === 'drink' && targetItem.sizes.length === 1)
            "
            :targetItem="targetItem"
          />
          <set-extra-ingredients-step
            v-else-if="
              targetItem.mode === 'drink' && targetItem.sizes.length > 1
            "
            :targetItem="targetItem"
          />
          <set-edges-step v-else :targetItem="targetItem" />
        </div>
        <div
          v-show="currentStep === 6"
          :class="
            !showAllSteps ||
            targetItem.mode === 'step' ||
            (targetItem.mode === 'drink' &&
              (!targetItem.default_sizes || targetItem.sizes.length === 1))
              ? 'inactive'
              : ''
          "
        >
          <set-availability-step
            v-if="targetItem.mode === 'drink' && targetItem.default_sizes"
            :targetItem="targetItem"
          />
          <set-extra-ingredients-step v-else :targetItem="targetItem" />
        </div>
        <div
          v-show="currentStep === 7"
          :class="
            !showAllSteps || targetItem.mode !== 'pizza' ? 'inactive' : ''
          "
        >
          <set-availability-step :targetItem="targetItem" />
        </div>
      </base-steps>
    </div>

    <div v-else>
      <!-- se o item é produto -->
      <base-steps
        ref="stepper"
        hideButtons
        class="d-flex flex-column"
        style="min-height: 100%; align-items: stretch"
      >
        <div v-show="currentStep === 1">
          <edit-step
            v-if="editMode"
            :targetItem="targetItem"
            :originCatalog="originCatalog"
            @saveItem="save"
          />
          <set-info v-else ref="setInfoStep" :targetItem="targetItem" />
        </div>
        <div v-show="currentStep === 2" :class="editMode ? 'inactive' : ''">
          <set-availability-step
            v-if="targetItem.sizes.length === 1 && targetItem.type === 'flavor'"
            :targetItem="targetItem"
          />

          <set-sizes-on-drink-step
            v-else-if="
              (targetItem.sizes.length === 0 && targetItem.type === 'drink') ||
                targetItem.sizeInProduct === true
            "
            :targetItem="targetItem"
            @changeFooter="changeFooter"
          />

          <set-stages-step
            v-else-if="
              targetItem.type === 'step' && targetItem.sizes.length === 1
            "
            :targetItem="targetItem"
            :originCatalog="originCatalog"
            @changeFooter="changeFooter"
          />

          <set-prices-on-sizes-step v-else :targetItem="targetItem" />
        </div>
        <div
          v-show="currentStep === 3"
          :class="
            (targetItem.sizes.length === 1 && targetItem.type === 'flavor') ||
            editMode
              ? 'inactive'
              : ''
          "
        >
          <set-stages-step
            v-if="targetItem.type === 'step' && targetItem.sizes.length > 1"
            :targetItem="targetItem"
            :originCatalog="originCatalog"
            @changeFooter="changeFooter"
          />
          <set-availability-step v-else :targetItem="targetItem" />
        </div>
        <div
          v-show="currentStep === 4"
          :class="
            targetItem.type !== 'step' ||
            targetItem.sizes.length === 1 ||
            editMode
              ? 'inactive'
              : ''
          "
        >
          <set-availability-step :targetItem="targetItem" />
        </div>
      </base-steps>
    </div>

    <!-- Actions -->
    <template
      v-if="currentStep !== 1 || (targetItem.type !== 'category' && !editMode)"
      v-slot:footer
    >
      <div
        v-if="!alternativeFooter"
        class="d-flex align-center"
        :class="currentStep === 1 ? 'flex-end' : 'justify-between'"
      >
        <base-button
          v-if="currentStep !== 1"
          design="four"
          class="mr_5 big"
          @click="prev()"
        >
          <span><i class="fal fa-chevron-left"></i></span>
        </base-button>

        <base-button class="ml_5 big" @click="isLastStep ? save() : next()">
          <span>
            <i v-if="isLastStep" class="fal fa-check"></i>
            <i v-else class="fal fa-chevron-right"></i>
          </span>
        </base-button>
      </div>
    </template>
  </base-drawer>
</template>

<script>
import BaseDrawer from '@/components/Drawer';
import BaseSteps from '@/components/Steps';
import BaseButton from '@/components/Button';
import BaseCard from '@/components/Card';
import BaseQuestion from '@/components/Question';
// category steps
import SelectCategoryStep from '@/containers/Catalog/CategorySteps/SelectCategoryStep.vue';
import SelectDrinkSizeStep from '@/containers/Catalog/CategorySteps/SelectDrinkSizeStep.vue';
import SelectSizeStep from '@/containers/Catalog/CategorySteps/SelectSizeStep.vue';
import SetSizesStep from '@/containers/Catalog/CategorySteps/SetSizesStep.vue';
import SetDoughsStep from '@/containers/Catalog/CategorySteps/SetDoughsStep.vue';
import SetEdgesStep from '@/containers/Catalog/CategorySteps/SetEdgesStep.vue';
import SetExtraIngredientsStep from '@/containers/Catalog/CategorySteps/SetExtraIngredientsStep.vue';
// category/product steps
import SetAvailabilityStep from '@/containers/Catalog/CategorySteps/SetAvailabilityStep.vue';
import EditStep from '@/containers/Catalog/CategorySteps/EditStep.vue';
// product steps
import SetInfo from '@/containers/Catalog/ProductSteps/SetInfo.vue';
import SetPricesOnSizesStep from '@/containers/Catalog/ProductSteps/SetPricesOnSizesStep.vue';
import SetSizesOnDrinkStep from '@/containers/Catalog/ProductSteps/SetSizesOnDrinkStep.vue';
import SetStagesStep from '@/containers/Catalog/ProductSteps/SetStagesStep.vue';
// libs
import Builder from 'easyjs/lib/Schema/Components/Builder';

export default {
  components: {
    BaseDrawer,
    BaseSteps,
    BaseButton,
    BaseCard,
    BaseQuestion,
    SelectCategoryStep,
    SelectSizeStep,
    SetSizesStep,
    SetDoughsStep,
    SetEdgesStep,
    SetExtraIngredientsStep,
    SetAvailabilityStep,
    SelectDrinkSizeStep,
    SetInfo,
    SetPricesOnSizesStep,
    SetSizesOnDrinkStep,
    SetStagesStep,
    EditStep,
  },
  data() {
    return {
      originalItem: Builder.factory('Base'),
      targetItem: Builder.factory('Base'),
      openDrawer: false,
      closedDrawer: false,
      currentStep: 1,
      showAllSteps: false,
      parentName: '',
      isLastStep: false,
      alternativeFooter: false,
      editMode: false,
    };
  },
  props: {
    originCatalog: {},
  },
  methods: {
    getTitle() {
      const titles = {
        pizza: 'Pizza',
        drink: 'Bebidas',
        step: 'Outros',
      };

      if (this.targetItem.type !== 'category') {
        if (this.editMode) return `Editar produto - ${this.targetItem.name}`;

        if (this.alternativeFooter) {
          return this.targetItem.type === 'step'
            ? `Adicionar etapa - ${this.parentName}`
            : `Adicionar tamanho - ${this.parentName}`;
        }

        return `Adicionar produto - ${this.parentName}`;
      }

      if (this.editMode) return `Editar categoria - ${this.targetItem.name}`;

      return this.targetItem.mode
        ? `Adicionar categoria - ${titles[this.targetItem.mode]}`
        : 'Adicionar categoria';
    },
    changeModel(item, parent, edit) {
      if (item) {
        this.originalItem = item;

        this.targetItem = Builder.mountSchema(JSON.parse(JSON.stringify(item)));
      }

      let parentBuild = {};

      if (parent) {
        parent = this.originCatalog.getItemsByParam('_id', parent)[0];
        parentBuild = Builder.mountSchema(JSON.parse(JSON.stringify(parent)));

        this.parentName = parentBuild.name;
      }

      this.setModel(parentBuild);
      this.editMode = edit;
      this.openDrawer = !this.openDrawer;
    },
    setModel(parent) {
      if (this.targetItem.type !== 'category') {
        this.targetItem.parent_ref = parent;
        this.targetItem.parent = parent._id || null;
        if (this.targetItem.sizes.length === 0) {
          this.targetItem.addItems(parent.sizes);
        }

        this.targetItem.sizes.map(size => {
          if (size.originalPrice > size.price) {
            let aux = size.price;
            size.price = size.originalPrice;
            size.originalPrice = aux;
          }
        });
      }
    },
    selectCategory(mode) {
      const availableModes = ['pizza', 'drink', 'step'];

      if (availableModes.includes(mode) && !this.targetItem._id) {
        this.targetItem.mode = mode;
        this.next('category_stepper');
      }
    },
    next() {
      const canGoToNextStep =
        this.targetItem.type === 'category'
          ? this.canGoToNextStepInCategory(this.currentStep)
          : this.canGoToNextStepInProduct(this.currentStep);

      if (this.$refs.stepper && canGoToNextStep) {
        let withTimeout = false;
        if (this.currentStep === 2) {
          this.showAllSteps = true;
          withTimeout = true;
          this.$forceUpdate();
        }

        if (withTimeout) {
          setTimeout(() => {
            this.$refs.stepper.next();
            this.currentStep = this.$refs.stepper.current;
          }, 250);
        } else {
          this.$refs.stepper.next();
          this.currentStep = this.$refs.stepper.current;
        }
      }
    },
    prev() {
      if (this.$refs.stepper) {
        let withTimeout = false;

        if (this.targetItem.type === 'category' && this.currentStep === 2) {
          this.targetItem = Builder.mountSchema(
            JSON.parse(JSON.stringify(this.originalItem))
          );
        }

        if (this.currentStep === 3) {
          this.showAllSteps = false;
          withTimeout = true;
        }

        if (withTimeout) {
          setTimeout(() => {
            this.$refs.stepper.prev();
            this.currentStep = this.$refs.stepper.current;
          }, 250);
        } else {
          this.$refs.stepper.prev();
          this.currentStep = this.$refs.stepper.current;
        }
      }
    },
    onCloseDrawer() {
      if (this.editMode) {
        setTimeout(() => {
          this.editMode = false;
        }, 200);
      }

      if (this.$refs.setInfoStep) this.$refs.setInfoStep.errors = { main: [] };

      if (this.$refs.stepper && this.$refs.stepper.current > 1) {
        this.targetItem = Builder.mountSchema(
          JSON.parse(JSON.stringify(this.originalItem))
        );

        setTimeout(() => {
          this.$refs.stepper.current = 1;
          this.currentStep = 1;
          this.showAllSteps = false;
          this.isLastStep = false;
          this.alternativeFooter = false;
        }, 200);
      }
    },
    canGoToNextStepInCategory(currentStep) {
      if (currentStep === 1) return true;

      switch (currentStep) {
        case 2:
          if (!this.targetItem.name) {
            this.$refs.categoryStep2.emptyNameError = true;
            alert(`${StringLanguage.errorEmptyName} para sua categoria.`);
            return false;
          }

          this.$refs.categoryStep2.emptyNameError = false;

          if (this.targetItem.sizes.length <= 0) {
            alert('Nenhum tamanho foi definido');
            return false;
          }

          return true;
        case 3:
          if (this.targetItem.mode !== 'drink') {
            if (this.targetItem.sizes.length > 1) {
              if (
                this.targetItem.sizes.filter(
                  size =>
                    !size.name ||
                    (this.targetItem.mode === 'pizza' && !size.max)
                ).length > 0
              ) {
                alert(
                  this.targetItem.mode === 'pizza'
                    ? StringLanguage.errorEmptyMaxOrSizeName
                    : 'Configure o nome do tamanho corretamente.'
                );
                return false;
              }
            } else {
              if (this.targetItem.mode === 'pizza') {
                if (
                  this.targetItem.sizes.filter(size => size.max).length === 0
                ) {
                  if (this.$refs.categoryStep3)
                    this.$refs.categoryStep3.emptyMaxFlavorError.oneSize = true;

                  alert(StringLanguage.errorEmptyMax);
                  return false;
                }

                if (this.$refs.categoryStep3)
                  this.$refs.categoryStep3.emptyMaxFlavorError.oneSize = false;
              }
            }
          } else {
            if (this.targetItem.sizes.length === 1) {
              const isValidSizes = this.targetItem.sizes
                .filter(s => !s.delete)
                .reduce(
                  (c, s) => c && !!s.unit && !!s.amount && !!s.package,
                  true
                );
              if (!isValidSizes) {
                if (this.$refs.categoryStep3)
                  this.$refs.categoryStep3.emptyValidSizes.oneSize = true;

                alert(
                  `O volume, medida e embalagem dos tamanhos são obrigatórios`
                );
                return false;
              }

              if (this.$refs.categoryStep3)
                this.$refs.categoryStep3.emptyValidSizes.oneSize = false;
            }
          }

          return true;
        case 4:
          // TODO: implementar validação da quarta etapa
          if (
            this.targetItem.mode === 'drink' &&
            this.targetItem.default_sizes
          ) {
            const isValidSizes = this.targetItem.sizes
              .filter(s => !s.delete)
              .reduce(
                (c, s) => c && !!s.unit && !!s.amount && !!s.package,
                true
              );
            if (!isValidSizes) {
              alert(
                `O volume, medida e embalagem dos tamanhos são obrigatórios`
              );
              return false;
            }
          }

          return true;
        default:
          return true;
      }
    },
    canGoToNextStepInProduct(currentStep) {
      switch (currentStep) {
        case 1:
          if (!this.targetItem.name) {
            alert(`${StringLanguage.errorEmptyName} para o seu produto.`);
            this.$refs.setInfoStep.highlightErrorFields();
            return false;
          }

          if (this.targetItem.type === 'drink' && !this.targetItem.group) {
            alert(`${StringLanguage.errorDrinkGroupRequired}`);
            return false;
          }
          return true;
        case 2:
          if (
            this.targetItem.type === 'flavor' &&
            this.targetItem.sizes.length > 1
          ) {
            if (
              this.targetItem.sizes.filter(size => parseFloat(size.price) === 0)
                .length > 0
            ) {
              alert('Configure o valor dos tamanhos corretamente.');
              return false;
            }
          } else if (this.targetItem.type === 'drink') {
            if (this.targetItem.sizes.length === 0) {
              alert('Configure um tamanho para o seu produto.');
              return false;
            }
          }
          return true;
        case 3:
          // TODO: implementar validação da terceira etapa
          return true;
        default:
          return true;
      }
    },
    save() {
      if (!this.validateItem(this.targetItem)) {
        return;
      }

      if (this.targetItem.sizes.length > 0) {
        this.targetItem.sizes = this.targetItem.sizes.filter(i => !!i.name);
      }

      let sizesIds = this.targetItem.sizes.map(s => s._id);

      if (this.targetItem.edges.length > 0) {
        this.targetItem.edges = this.targetItem.edges
          .map(i => {
            if (!i.name) {
              if (i.new) {
                return null;
              }
              i.delete = true;
            }

            return i;
          })
          .filter(i => !!i)
          .map(i => {
            i.sizes = i.sizes.filter(s => sizesIds.indexOf(s._id) > -1);
            return i;
          });
      }

      if (this.targetItem.extra_ingredients.length > 0) {
        this.targetItem.extra_ingredients = this.targetItem.extra_ingredients
          .map(i => {
            if (!i.name) {
              if (i.new) {
                return null;
              }
              i.delete = true;
            }

            return i;
          })
          .filter(i => !!i)
          .map(i => {
            i.sizes = i.sizes.filter(s => sizesIds.indexOf(s._id) > -1);
            return i;
          });
      }

      if (this.targetItem.doughs.length > 0) {
        this.targetItem.doughs = this.targetItem.doughs
          .map(i => {
            if (!i.name) {
              if (i.new) {
                return null;
              }
              i.delete = true;
            }

            return i;
          })
          .filter(i => !!i)
          .map(i => {
            i.sizes = i.sizes.filter(s => sizesIds.indexOf(s._id) > -1);
            return i;
          });
      }

      this.closedDrawer = !this.closedDrawer;
      this.$emit('updateCatalog', this.targetItem);
    },
    validateItem(item) {
      if (item.type == 'category') {
        if (!item.name) {
          alert(`${StringLanguage.errorEmptyName} para sua categoria.`);
          return false;
        }

        if (item.mode == 'pizza') {
          if (item.sizes.length > 1) {
            //Verificar se existem ao menos duas categorias com nome configurado
            let correctSizes = item.sizes.filter(s => !!s.name);
            if (correctSizes.length < 2) {
              alert(StringLanguage.errorEmptyMaxOrSizeName);
              return false;
            }

            //Verificar se esses tamanhos tem o máximo de itens configurado
            if (correctSizes.filter(s => !s.max).length > 0) {
              alert(StringLanguage.errorEmptyMaxOrSizeName);
              return false;
            }
          } else {
            //Verificar se esse tamanho tem o máximo de itens configurados configurado
            if (!!!item.sizes[0].max) {
              alert(StringLanguage.errorEmptyMax);
              return false;
            }
          }
        }

        if (item.mode == 'drink') {
          if (this.editMode) {
            return true;
          }

          if (item.default_sizes) {
            if (item.sizes.length == 0) {
              alert(`${StringLanguage.errorSizeRequired} para o seu produto.`);
              return false;
            } else {
              const isValidSizes = item.sizes
                .filter(s => !s.delete)
                .reduce(
                  (c, s) => c && !!s.unit && !!s.amount && !!s.package,
                  true
                );
              if (!isValidSizes) {
                alert(
                  `O volume, medida e embalagem dos tamanhos são obrigatórios`
                );
                return false;
              }
            }
          }
        }
      } else {
        if (!item.name) {
          alert(`${StringLanguage.errorEmptyName} para o seu produto.`);
          return false;
        }

        const hasSizeSaleError = item.sizes.find(
          size =>
            parseFloat(size.price) > 0 &&
            parseFloat(size.price) <= parseFloat(size.originalPrice)
        );
        const hasSaleError =
          parseFloat(item.price) > 0 &&
          parseFloat(item.price) <= parseFloat(item.originalPrice);
        if (!!hasSizeSaleError || !!hasSaleError) {
          alert(`Preço de promoção deve ser menor que o valor.`);
          return false;
        }

        /* Aplicando regra de promoção:
          - menor preço maior que zero se refere a promoção (assume a prop price)
          - outro valor fica na prop de apoio originalPrice
        */
        if (item.sizes.length) {
          item.sizes.map(size => {
            if (size.originalPrice > 0 && size.originalPrice < size.price) {
              let aux = size.price;
              size.price = size.originalPrice;
              size.originalPrice = aux;
            }
          });
        } else {
          if (item.originalPrice > 0 && item.originalPrice < item.price) {
            let aux = item.price;
            item.price = item.originalPrice;
            item.originalPrice = aux;
          }
        }

        if (item.type == 'drink') {
          const parentProduct = item.parent_ref;
          const sizesLength = item.sizes.filter(s => !s.delete).length;

          if (!item.group) {
            alert(`${StringLanguage.errorDrinkGroupRequired}`);
            return false;
          }

          if (this.editMode) {
            return true;
          }

          if (!parentProduct.default_sizes) {
            if (sizesLength == 0) {
              alert(`${StringLanguage.errorSizeRequired} para o seu produto.`);
              return false;
            } else {
              const isValidSizes = item.sizes
                .filter(s => !s.delete)
                .reduce(
                  (c, s) => c && !!s.unit && !!s.amount && !!s.package,
                  true
                );
              if (!isValidSizes) {
                alert(
                  `O volume, medida e embalagem dos tamanhos são obrigatórios`
                );
                return false;
              }
            }
          }
        }
      }

      //verifica se tem disponibilidade configurada
      if (item.availability) {
        //verifica se ao menos 1 dia da semana foi selecionado
        if (!item.availability.daysOfTheWeek) {
          alert(StringLanguage.errorEmptyDay);
          return false;
        }

        //verifica se tem algum período
        if (!item.availability.periods.length) {
          alert(StringLanguage.errorEmptyPeriod);
          return false;
        }

        //percorre períodos para validação
        for (let period of item.availability.periods) {
          //verifica se algum horário não está preenchido
          if (!period.beginTime || !period.endTime) {
            alert(StringLanguage.errorInvalidPeriod);
            return false;
          }

          //aplica validação de horário informado
          if (
            !this.validateTime(period.beginTime) ||
            !this.validateTime(period.endTime)
          ) {
            alert(StringLanguage.errorInvalidPeriod);
            return false;
          }

          //verifica se o horário inicial é maior que o final
          if (
            +period.beginTime.replace(':', '') >
            +period.endTime.replace(':', '')
          ) {
            alert(StringLanguage.errorInvalidTime);
            return false;
          }
        }
      }

      return true;
    },
    validateTime(value) {
      let [hours, minutes] = value
        .replace(':', '')
        .padEnd(4, '0')
        .match(/.{1,2}/g);
      let date = new Date(0, 0, 0, hours, minutes);
      if (hours != date.getHours() || minutes != date.getMinutes()) {
        return false;
      }
      return true;
    },
    changeFooter(value) {
      this.alternativeFooter = value;
    },
  },
  watch: {
    currentStep(newValue) {
      if (this.targetItem.type !== 'category') {
        this.isLastStep = newValue === this.$refs.stepper.steps;
      } else {
        this.isLastStep = newValue > 2 && newValue === this.$refs.stepper.steps;
      }
    },
  },
};
</script>
<style scoped>
.flex-end {
  justify-content: flex-end;
}
</style>
